/* Parbiart — kollekcióoldal: a rendezőpirulák a gyári „Rendezés" mezőt állítják
   (sections/pb-kollekcio-fej.liquid). A gyári facets.js így a szűrőkkel együtt, újratöltés
   nélkül frissíti a rácsot. Ha a gyári mező nincs a lapon, a pirula sima linkként működik. */
(function () {
  var bar = document.querySelector('[data-pb-sort]');
  if (!bar) return;

  function mark(value) {
    bar.querySelectorAll('.pb-sortb').forEach(function (a) {
      if (a.dataset.sort === value) a.setAttribute('aria-current', 'true');
      else a.removeAttribute('aria-current');
    });
  }

  bar.addEventListener('click', function (e) {
    var a = e.target.closest('.pb-sortb');
    if (!a) return;
    var select = document.getElementById('SortBy');
    if (!select || !select.querySelector('option[value="' + a.dataset.sort + '"]')) return; // sima link
    e.preventDefault();
    select.value = a.dataset.sort;
    var mobile = document.getElementById('SortBy-mobile');
    if (mobile) mobile.value = a.dataset.sort;
    mark(a.dataset.sort);
    select.dispatchEvent(new Event('input', { bubbles: true }));
  });

  // a gyári mezőből (mobil szűrőfiók) vagy a böngésző „vissza" gombjával váltott rendezés
  document.addEventListener('input', function (e) {
    if (e.target && e.target.name === 'sort_by') mark(e.target.value);
  });
  window.addEventListener('popstate', function () {
    var v = new URLSearchParams(location.search).get('sort_by');
    if (v) mark(v);
  });
})();

/* A mozaik széles kártyái (minden 8. hely) kétszer akkora képet kérnek, mint amire a gyári
   kártya „sizes" értéke számol (az mindig negyed szélesség) — mérve: 497 px-es helyre 360 px-es
   kép töltődött. Itt a széles helyek képei valós méretet kapnak; szűrés/rendezés után újra. */
(function () {
  var box = document.getElementById('ProductGridContainer');
  if (!box || !box.closest('.facets-vertical')) return;
  function fix() {
    box.querySelectorAll('#product-grid > .grid__item:nth-child(8n + 1) img[srcset]').forEach(function (img) {
      img.sizes = '(min-width: 990px) 520px, (min-width: 750px) 45vw, 50vw';
    });
  }
  fix();
  new MutationObserver(fix).observe(box, { childList: true, subtree: true });
})();

/* Hosszú kollekcióleírás: a gomb csak akkor látszik, ha a szöveg nem fér ki három sorban. */
(function () {
  document.querySelectorAll('.pb-collhead__more').forEach(function (btn) {
    var box = document.getElementById(btn.getAttribute('aria-controls'));
    if (!box) return;
    if (box.scrollHeight > box.clientHeight + 2) btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? btn.dataset.kevesebb : btn.dataset.tobb;
    });
  });
})();
